import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type SheetInformationDb = {
  sheetId: string;
  name: string;
  content: string;
  order: number;
  goodsId?: string;
  version?: number;
}
const initial: SheetInformationDb = {
  sheetId: '',
  name: '',
  content: '',
  order: 0,
  goodsId: undefined,
  version: undefined
};

export type SheetInformationDbHashType = {
  [key in string]: SheetInformationDb;
}

export type SheetInformationAddPayload = {
  id?: string;
} & SheetInformationDb;
export type SheetInformationUpdatePayload = {
  id: string;
} & { [P in keyof SheetInformationDb]?: SheetInformationDb[P] };

export type SheetInformationDbState = {
  sheetInformations: SheetInformationDbHashType;
}

export const  generateSheetInformationId = () : string =>  generateId('si');
let initialState: SheetInformationDbState = { sheetInformations: {} };
const key = 'sheetInformations';

const sheetInformationDbSlice = createSlice({
  name: 'sheetInformationDb',
  initialState,
  reducers: {
    initializeSheetInformations(state: SheetInformationDbState) {
      state.sheetInformations = {};
    },
    addSheetInformation(state: SheetInformationDbState, action: PayloadAction<SheetInformationAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateSheetInformationId();
      state.sheetInformations[id] = obj;
      saveData(key, id, obj);
    },
    updateSheetInformation(state: SheetInformationDbState, action: PayloadAction<SheetInformationUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.sheetInformations[id] === undefined) {
        console.log(`*** SheetInformation not found: ${id}`);
      } else {
        const newData = { ...state.sheetInformations[id], ...obj };
        state.sheetInformations[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteSheetInformation(state: SheetInformationDbState, action: PayloadAction<SheetInformationUpdatePayload>) {
      const id = action.payload.id;
      delete state.sheetInformations[id];
      deleteData(key, id);
    },
    saveSheetInformations(state: SheetInformationDbState) {
      saveAllData(key, state.sheetInformations);
    },
    signUpSheetInformations(state: SheetInformationDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.sheetInformations, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: SheetInformationDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.sheetInformations = updatedValues;
      if (changed) saveAllData(key, state.sheetInformations);
    })
  }
})

export const { initializeSheetInformations, addSheetInformation, updateSheetInformation, deleteSheetInformation, saveSheetInformations, signUpSheetInformations } = sheetInformationDbSlice.actions;
export default sheetInformationDbSlice.reducer;
